export default __webpack_public_path__ + "static/media/tv.c85e2ddf.svg";